import React from 'react';
import "./style.css"

const SearchButton = ({ onClick, height }) => {
    return (
        <div
            className="search-side-btn d-flex align-items-center justify-content-center"
            style={{ height: height ?? "50px" }}
            onClick={onClick}
        >
            <i className="mdi mdi-magnify text-dark font-size-18 mx-1" />
        </div>
    );
};

export default SearchButton;
